import dateformat from 'dateformat'
import { connect } from 'react-redux'

import { InsertCardIcon } from 'components/icons'
import { getInsertCardOrders, getWantsInsertCards } from 'registry/reducers'

import SetupGoal from './setup-goal'

function getText(state) {
  const wants = getWantsInsertCards(state)
  const orders = getInsertCardOrders(state)

  if (wants == null || orders.length == 0) {
    return 'Order free insert cards!'
  }

  if (!wants) {
    return 'No insert cards ordered.'
  }

  const lastOrder = orders.pop()
  return `${lastOrder.quantity} insert cards ordered on ${dateformat(
    lastOrder.createdAt,
    'mmmm dS'
  )}.`
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    icon: <InsertCardIcon />,
    text: getText(state),
  }
}

export default connect(mapStateToProps)(SetupGoal)
